import { Component, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from "@angular/material/button";

@Component({
    selector: 'app-failure-dialog',
    template: `
        <div class="success-dialog">
            <h2 mat-dialog-title>Failed</h2>
            <mat-dialog-content>
                <p>{{ data.message }}</p>
            </mat-dialog-content>
            <mat-dialog-actions align="end">
                <button mat-button mat-dialog-close>Close</button>
            </mat-dialog-actions>
        </div>
    `,
    standalone: true,
    imports: [
        MatDialogModule,
        MatButtonModule
    ],
    styles: [`
        .success-dialog {
            text-align: center;
            padding: 10px 5px;
            max-width: 320px;
        }

        .dialog-title {
            font-size: 22px;
            font-weight: 600;
            color: #2e7d32;
            margin-bottom: 8px;
        }

        .dialog-content {
            font-size: 15px;
            color: #555;
            padding: 10px 20px;
        }

        .dialog-content p {
            margin: 0;
            line-height: 1.5;
        }

        .dialog-actions {
            margin-top: 12px;
        }

        button {
            min-width: 100px;
            font-weight: 500;
            border-radius: 6px;
        }
    `]
})
export class FailureDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string }) {}
}